import axios from 'axios';

import { toLocalISOString } from 'utils/date';

import { EMPLOYEES, USERS_EMPLOYEES } from 'RestAPIs/endpoints';

type Employee = {
  empId: number;
  nameCompound: string;
  nameCompoundSurname: string;
  nameInformal: string;
  nameSurnameCompound: string;
  nr: number;
};

export const getUsersEmployees = (date: Date, onlyFlex: boolean) => {
  const params: any = {
    isEmployedOn: toLocalISOString(date),
    isFlex: onlyFlex,
    isAvailableAsFlex: onlyFlex,
    includeNotAllowed: onlyFlex
  };
  if (onlyFlex) {
    params.referenceDate = toLocalISOString(date);
  }

  return axios.get<Employee[]>(USERS_EMPLOYEES, {
    params
  });
};

export const getAllEmployees = () => {
  return axios.get<Employee[]>(USERS_EMPLOYEES);
};

type EmployeePOSTBody = {
  firstName: string;
  infix?: string;
  lastName: string;
  phoneNumber?: string;
  emailAddress: string;
  hourlyRate?: number;
  startDate: string;
  endDate?: string | null;
  selectedPlanunit: number;
  selectedFunction: number;
  selectedCla: number;
};

export type EmployeePOSTResponse = {
  firstName: string;
  infix: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  hourlyRate: number;
  startDate: string;
  endDate: string;
  nr: number;
  selectedPlanunit: number;
  selectedFunction: number;
  selectedCla: number;
  empId: number;
  nameCompound: string;
  nameCompoundSurname: string;
  nameInformal: string;
  nameSurnameCompound: string;
};

export const createNewEmployee = (employee: EmployeePOSTBody) =>
  axios.post<EmployeePOSTResponse>(EMPLOYEES, employee);
